// extracted by mini-css-extract-plugin
export default {"rating":"tK-z","numberOfStars":"uK-z","count":"vK-z","barGraphSpacing":"wK-z","barGraph":"xK-z"};